import React from 'react';

type EditIconProps = {
  className?: string;
  onClick?: () => void;
  size?: number;
  color?: string | undefined;
  strokeWidth?: number
};

const EditIcon = ({ color = '#292D32', size = 19,strokeWidth=1.2, className, onClick }: EditIconProps) => (
  <svg width={size} height={size} viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg" className={className} onClick={onClick}>
    <path d="M10.445 3.20001L4.28751 9.71751C4.05501 9.96501 3.83001 10.4525 3.78501 10.79L3.50751 13.22C3.41001 14.0975 4.04001 14.6975 4.91001 14.5475L7.32501 14.135C7.66251 14.075 8.13501 13.8275 8.36751 13.5725L14.525 7.05501C15.59 5.93001 16.07 4.64751 14.4125 3.08001C12.7625 1.52751 11.51 2.07501 10.445 3.20001Z" stroke={color} strokeWidth={strokeWidth} strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M9.41748 4.28751C9.73998 6.35751 11.42 7.94001 13.505 8.15001" stroke={color} strokeWidth={strokeWidth} strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M2.75 17H16.25" stroke={color} strokeWidth={strokeWidth} strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round" />
  </svg>

);

export default EditIcon;